import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { ReportLayout } from '../../../../../../api/reports.dao';
import { InfoPopover } from '../../../../../global/info-popover/info-popover';
import { OERadioOptions } from '../../../../../global/oe-radio-options/oe-radio-options';

interface IProps {
    intl: IntlShape;
    layoutType: ReportLayout;
    applyLayout: (value: ReportLayout) => void;
}
export const LayoutOption = injectIntl(mobxReact.observer((props: IProps): JSX.Element => {
    const { intl, layoutType, applyLayout } = props;

    const layoutOptionsInfoMessage = intl.formatMessage({
        id: 'oe.reports.layoutOptionsInfoMessage',
        defaultMessage: `The 'One row per attendee' layout will provide a single row 
    for each Event Attendee, with columns for their interaction status with respect to each of the meetings selected for the report.  
    The 'One row per attendee per meeting' layout has a single 
    interaction status column, and will have multiple rows for each attendee, if multiple meetings are included in the report.`,
        description: 'Info label'
    });

    return (
        <div className='generate-event-report__sidebar-layout'>
            <div className='generate-event-report__label'>
                <FormattedMessage
                    id='oe.reports.layoutOptions'
                    defaultMessage='Layout Options'
                    description='Label text'
                />
                <div className='generate-event-report__layout-info-message'>
                    <InfoPopover>
                        <div>{layoutOptionsInfoMessage}</div>
                    </InfoPopover>
                </div>
            </div>
            <OERadioOptions
                options={[
                    {
                        label: intl.formatMessage({
                            id: 'oe.reports.oneRowPerAttendee',
                            description: 'Label text',
                            defaultMessage: '1 Row per Attendee (default)'
                        }),
                        value: ReportLayout.ROW_PER_ATTENDEE
                    },
                    {
                        label: intl.formatMessage({
                            id: 'oe.reports.oneRowPerAttendeePerMeeting',
                            description: 'Label text',
                            defaultMessage: '1 Row per Attendee per Meeting'
                        }),
                        value: ReportLayout.ROW_PER_ATTENDEE_PER_MEETING
                    }
                ]}
                value={layoutType}
                onOptionToggle={(value: ReportLayout) => applyLayout(value)}
            />
        </div>
    );
}));
